var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21297_28146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2726 3.04443H3.42612C2.61168 3.04443 1.94531 3.7584 1.94531 4.63102V18.9103L4.90694 15.7371H15.2726C16.0871 15.7371 16.7534 15.0231 16.7534 14.1505V4.63102C16.7534 3.7584 16.0871 3.04443 15.2726 3.04443ZM15.2726 14.1505H4.90694L3.42612 15.7371V4.63102H15.2726V14.1505Z",
    fill: "#323640"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21297_28146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7697,
    height: 19.039,
    fill: "white",
    transform: "matrix(-1 0 0 1 18.2695 0.878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chatBubble.fff89cf1b46373338d8150144949ba4e.svg";
export { ForwardRef as ReactComponent };